import { g as get_data } from "../../../../../../chunks/get_data.js";
const load = async (event) => {
  return get_data(event);
};
export {
  load
};
//# sourceMappingURL=_page.server.ts.js.map
